import { IApp } from '@/types/nuxt'
import refresh from '@/utils/refresh'

export default class GetUnreadUseCase implements BaseUseCase {
  constructor(protected App: IApp) {}

  async execute() {
    try {
      await refresh(this.App)
      return await this.App.monitaroGateway.Notification.GetUnread()
    } catch (exception: any) {
      this.App.logService.handle(exception)
    }
    return null
  }
}
